export default __webpack_public_path__ + "static/media/schedule.ff3dd34b.svg";